import { useSelector } from 'react-redux';
import { useLocation, useRouteLoaderData } from 'react-router';
import { SubscriptionCategory } from '../../../../../common/enums';
import { deepEqual } from '../../../../../common/utils/objectUtils';
import {
  getSubCategoryFromPath,
  pendingSubscriptionActionExistsInState,
} from '../../../../../common/utils/subscriptionUtils';
import { SubscriptionBillingAccountUserInformation } from '../../../../../components/SubscriptionDetails/SubscriptionBillingAccountUserInformation';
import { getMobileSubscriptionLayout } from '../../../../../components/SubscriptionLayout/subscriptionLayoutUtils';
import type { MobileSubscriptionLoaderResponse } from '../../../../../common/loaders';
import type { State } from '../../../../../selfservice/common/store';

export const MobileBillingAccountUserInformationPath = () => {
  const { pathname } = useLocation();
  const category = getSubCategoryFromPath(pathname);
  const {
    subscription,
    hasPendingActions,
    companyInfo,
    contacts,
    addOnRules,
    addOnRulesMobilePbx,
    billingAccounts,
    billChannels,
    subscriptionScheduledChanges,
  } = useRouteLoaderData(
    category === SubscriptionCategory.VOICE ? 'voiceSub' : 'broadbandSub'
  ) as MobileSubscriptionLoaderResponse;
  const subscriptionActionsState = useSelector((s: State) => s?.selfservice?.pendingSubscriptionActions, deepEqual);

  const MobileSubLayout = getMobileSubscriptionLayout(category);

  return (
    <MobileSubLayout
      addOnRules={addOnRules}
      addOnRulesMobilePbx={addOnRulesMobilePbx}
      contacts={contacts}
      companyInfo={companyInfo}
      subscription={subscription}
    >
      <SubscriptionBillingAccountUserInformation
        subscription={subscription}
        hasPendingActions={
          hasPendingActions ||
          pendingSubscriptionActionExistsInState(subscription.subscriptionId, subscriptionActionsState)
        }
        companyInfo={companyInfo}
        billingAccounts={billingAccounts}
        contacts={contacts}
        billChannels={billChannels}
        subscriptionScheduledChanges={subscriptionScheduledChanges}
      />
    </MobileSubLayout>
  );
};
